import React, { useState } from 'react';
import { Button } from './button';
import { faExpand, faTable } from '@fortawesome/free-solid-svg-icons';
import { Table } from 'antd';
import { TableModal } from './tableModal';
import { DataType, camelToTitleCase } from '@quyva/common';

// Get a cell value from a row regardless of whether it's an array or an object.
// If the value is itself an object (e.g. a JSONB column), stringify it so React can render it.
const getCellValue = (row, column, columnIndex) => {
    const raw = Array.isArray(row) ? row[columnIndex] : row[column];
    if (raw !== null && raw !== undefined && typeof raw === 'object') {
        return JSON.stringify(raw);
    }
    return raw;
};

export const ExpandableTable = ({
    columnData,
    tableData,
    pageSize,
    pagination,
    isSmallScreen,
    expandedTableTitle,
    extraContent,
}) => {
    const [displayTableModal, setDisplayTableModal] = useState(false);

    if (
        columnData &&
        tableData &&
        Array.isArray(columnData) &&
        Array.isArray(tableData)
    ) {
        let columns = [];
        let dataSource = [];

        if (tableData.length > pageSize || columnData.length > pageSize) {
            const extraSign = '...';

            const columnIterationSize =
                pageSize < columnData.length ? pageSize : columnData.length;
            for (let i = 0; i < columnIterationSize; i++) {
                const data =
                    i === columnIterationSize - 1 && columnIterationSize !== 1
                        ? extraSign
                        : columnData[i];
                const singleColumnData = {
                    title: camelToTitleCase(data),
                    dataIndex: data,
                    key: data,
                };
                columns.push(singleColumnData);
            }

            const rowIterationSize =
                pageSize < tableData.length ? pageSize : tableData.length;
            for (let i = 0; i < rowIterationSize; i++) {
                const dataObj = { key: i };
                for (let index = 0; index < columnIterationSize; index++) {
                    const key =
                        index === columnIterationSize - 1 &&
                        columnIterationSize !== 1
                            ? extraSign
                            : columnData[index];
                    dataObj[key] =
                        i === rowIterationSize - 1 ||
                        (index === columnIterationSize - 1 &&
                            columnIterationSize !== 1)
                            ? extraSign
                            : getCellValue(tableData[i], columnData[index], index);
                }
                dataSource.push(dataObj);
            }
        } else {
            columns = columnData.map((column, index) => {
                return {
                    title: camelToTitleCase(column),
                    dataIndex: column,
                    key: column,
                    sorter: (a, b) => {
                        if (
                            typeof a[column] &&
                            typeof b[column] === DataType.NUMBER
                        ) {
                            return a[column] - b[column];
                        }
                        return a[column]
                            .toString()
                            .localeCompare(b[column].toString());
                    },
                };
            });

            dataSource = tableData.map((data, index) => {
                const dataObj = { key: index };
                columnData.forEach((column, columnIndex) => {
                    dataObj[column] = getCellValue(data, column, columnIndex);
                });
                return dataObj;
            });
        }

        return (
            <>
                {displayTableModal && (
                    <TableModal
                        title={
                            expandedTableTitle
                                ? expandedTableTitle
                                : 'Table Data'
                        }
                        extraContent={extraContent}
                        titleIcon={faTable}
                        iconColor={'sky'}
                        onClose={() => setDisplayTableModal(false)}
                        tableColumns={columnData}
                        tableData={tableData}
                        pagination={null}
                        modalClassName={
                            isSmallScreen ? 'w-full' : 'w-fit max-w-full'
                        }
                        isSmallScreen={isSmallScreen}
                    />
                )}
                <div className='w-full flex-col'>
                    {extraContent && (
                        <div
                            className={`py-2 ${isSmallScreen ? 'text-sm' : ''}`}
                        >
                            {extraContent}
                        </div>
                    )}
                    <div className='w-full flex justify-between items-center break rounded-t-xl mb-1'>
                        <div className='p-1 font-semibold text-texts-secondary300'>
                            <span className='pr-2'>
                                Rows:
                                <span className='ml-1 text-backgrounds-primary400'>
                                    {tableData.length}
                                </span>
                            </span>
                            <span className='px-2'>
                                Columns:
                                <span className='ml-1 text-backgrounds-primary400'>
                                    {columnData.length}
                                </span>
                            </span>
                        </div>
                        <Button
                            type={'success'}
                            icon={faExpand}
                            //text={isSmallScreen ? null : 'Expand Table'}
                            hoverText={'Expand to view the full table data'}
                            className=''
                            onClick={() => {
                                setDisplayTableModal(true);
                            }}
                        />
                    </div>
                    <div className='overflow-x-auto'>
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            bordered={true}
                            pagination={pagination}
                            size='small'
                        />
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <div>
                Unable to convert into your answer into correct tabular format,
                please try again!
            </div>
        );
    }
};
